<template>
	<div v-if="data" :class="['sub-values', {'inline': data.postalCodes.length === 1}]">
		<div
			v-for="postalCode in data.postalCodes"
			:key="postalCode.id"
			class="sub-value"
		>
			<div class="label clickable" @click="$emit('click')">
				<Label :characteristic="postalCode.characteristic"/> ({{ postalCode.postalCode }})
			</div>
		</div>
	</div>
</template>

<script>
import Label from "@/vue/characteristic/Label.vue";

export default {
	components: {Label},

	props: {
		data: {
			type: Object,
			required: false
		}
	}
}
</script>
